module.exports = __webpack_public_path__ + "img/8.933fd0ed.png";